import { render, staticRenderFns } from "./ExerciseForm.vue?vue&type=template&id=af6490bc&"
import script from "./ExerciseForm.vue?vue&type=script&lang=js&"
export * from "./ExerciseForm.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports